import bem from "easy-bem";
import { useIsMobile } from "hooks/useIsMobile";
import React from "react";

import ScrollToTopButton from "./ScrollToTopButton";
import "./footer.css";

const cn = bem("site-footer");

type FooterProps = {
  hideBackLink?: boolean;
  children?: React.ReactNode;
};

const Footer: React.FC<FooterProps> = ({ hideBackLink = false, children }) => {
  const { isMobile, toggleMobile } = useIsMobile();

  return (
    <footer className={cn()}>
      <div className={cn("left")}>
        {!hideBackLink && <a href="/#">Назад к списку всех проблем</a>}
        {children}
      </div>

      <div className={cn("right")}>
        <a
          href="/#"
          onClick={(e) => {
            e.preventDefault();
            toggleMobile();
            window.location.reload();
          }}
        >
          {isMobile ? "На десктопную версию" : "На мобильную версию"}
        </a>

        <ScrollToTopButton />
      </div>
    </footer>
  );
};

export default Footer;
